import { useState } from 'react';
import styles from './PartnerTaskItem.module.css';
import Reward from '../Reward/Reward';
import ButtonLoader from '../ButtonLoader/ButtonLoader';
import type { TaskDetails } from '../../pages/TasksPage/PartnerTasks/adapters/subgramAdapter';

const PartnerTaskItem = ({
  task,
  onClick,
  buttonText,
}: {
  task: TaskDetails;
  onClick?: () => void;
  buttonText?: string;
}) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const isCompleted = buttonText === 'Выполнssено' || task.status === 'CLAIMED';

  const handleClick = async () => {
    if (isProcessing || !onClick || isCompleted) return; // Блокируем повторные клики

    setIsProcessing(true);
    try {
      await onClick();
    } catch (error) {
      console.error('Ошибка при выполнении партнёрского задания:', error);
    } finally {
      // Добавляем небольшую задержку для предотвращения случайных двойных кликов
      setTimeout(() => {
        setIsProcessing(false);
      }, 1000);
    }
  };
  const getFirstLetter = (title: string) => {
    // Регулярное выражение для проверки эмодзи
    const emojiRegex =
      /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{1F900}-\u{1F9FF}]|[\u{1F018}-\u{1F270}]|[\u{238C}-\u{2454}]|[\u{20D0}-\u{20FF}]|[\u{FE00}-\u{FE0F}]|[\u{1FAB0}-\u{1FABF}]|[\u{1FAC0}-\u{1FAFF}]|[\u{1FAD0}-\u{1FAFF}]|[\u{1FAE0}-\u{1FAFF}]|[\u{1FAF0}-\u{1FAFF}]/u;

    // Проверяем, является ли первый символ эмодзи
    if (emojiRegex.test(title[0])) {
      return title[0]; // Возвращаем эмодзи как есть
    }

    // Иначе возвращаем первую букву в верхнем регистре
    return title.charAt(0).toUpperCase();
  };
  console.log(task.icon, 'task.icon');
  return (
    <div
      className={`${styles.taskItem} ${isProcessing ? styles.processing : ''}`}
      onClick={handleClick}
    >
      <div className={styles.iconWrapper}>
        {task.icon && task.icon !== '' ? (
          <div className={styles.iconPictureWrapper}>
            <div className={styles.iconPicture}>
              <img src={task.icon} alt={task.title} />
            </div>
          </div>
        ) : (
          <div className={styles.iconLetter}>{getFirstLetter(task.title)}</div>
        )}
      </div>
      <div className={styles.titleWrapper}>
        <div className={styles.title}>{task.title}</div>
        <div className={styles.rewardWrapper}>
          <Reward reward={task.rewards.beastcoins} />
        </div>
      </div>
      <div className={styles.buttonWrapper}>
        {isProcessing ? (
          <ButtonLoader />
        ) : (
          <div className={isCompleted ? styles.buttonCompleted : styles.button}>
            {buttonText || 'Выполнить'}
          </div>
        )}
      </div>
    </div>
  );
};

export default PartnerTaskItem;
